import {NumberUDF} from "./UDFs/NumberUDF";
import {StringUDF} from "./UDFs/StringUDF";
import {BooleanUDF} from "./UDFs/BooleanUDF";

export class FindItemConfiguration {


  DefaultPowerLevelReader: NumberUDF;

  FilterRFIDLabel: StringUDF;

  FilterSKULabel: StringUDF;

  FilterUPCLabel: StringUDF;

  FindItemExpectedReportId: NumberUDF;

  ProximityAcceptanceCriteriaReader: NumberUDF;

  EnableZoneType: BooleanUDF;

  get(): any{
    return {
      DefaultPowerLevelReader: this.DefaultPowerLevelReader.value,
      FilterRFIDLabel: this.FilterRFIDLabel.value,
      FilterSKULabel: this.FilterSKULabel.value,
      FilterUPCLabel: this.FilterUPCLabel.value,
      ProximityAcceptanceCriteriaReader: this.ProximityAcceptanceCriteriaReader.value,
      FindItemExpectedReportId: this.FindItemExpectedReportId.value,
      EnableZoneType: this.EnableZoneType.value
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/findItem.config.ts